import { IDraggableHandler, IDroppableHandler } from "../../../components/drag-and-drop/models";
import { NodeDraggingModel, NodeModel } from "../../../models/node-model";
import { CostCenterConditionTargetingModel } from "./linked-mappings-service";
import { throttle, debounce } from "lodash";
import { OrganizationalNodeModel } from "../../customers/organizational-units/organizational-unit-service";
import { TreeNode } from "../../../components/tree-view/tree-node";

export class MappingDraggableModel {
	node: OrganizationalNodeModel;
	targetingModel: CostCenterConditionTargetingModel;
}

export class MappingDraggableHandler implements IDraggableHandler {
	onDragStart(event, data: OrganizationalNodeModel) {
		if (event.stopPropagation) {
			event.stopPropagation();
		}

		if (data.nodeType !== "CostCenter" || data.isIgnored) {
			event.dataTransfer.effectAllowed = 'uninitialized';
			event.preventDefault();
			return false;
		}

		const draggableModel = new MappingDraggableModel();
		draggableModel.node = data;

		event.dataTransfer.effectAllowed = 'linkMove';
		const json = JSON.stringify(draggableModel);
		event.dataTransfer.setData("application/json", json);
	}

	onDragEnd(event, data: any): void {}
}

export class MappingDroppableHandler implements IDroppableHandler {
	private onDropCallback: (serviceId: string, draggedNode: MappingDraggableModel) => void;

	private expandTimeout: any;

	set expandTimeoutValue(value) {
		clearTimeout(this.expandTimeout);
		this.expandTimeout = value;
	}

	constructor(onDropCallback: (serviceId: string, draggedNode: MappingDraggableModel) => void) {
		this.onDropCallback = onDropCallback;
	}

	onDragEnter(event: any, targetNode: TreeNode) {
		if (event.preventDefault) {
			event.preventDefault(); // Necessary. Allows us to drop.
		}
		event.dataTransfer.dropEffect = 'move';

		this.expandTimeoutValue = setTimeout(() => targetNode.isExpanded = true, 500);

		return false;
	}

	onDragLeave(event: Event, dragTarget: any): void {
		this.expandTimeoutValue = undefined;
	}

	onDrop(event, targetNode: TreeNode) {
		if (event.stopPropagation) {
			event.stopPropagation(); // stops the browser from redirecting.
		}

		const jsonData = event.dataTransfer.getData("application/json");
		const data = <MappingDraggableModel>JSON.parse(jsonData);

		this.onDropCallback(targetNode.current.id, data);
		targetNode.isExpanded = true;

		return false;
	}
}

